import { Injectable, OnChanges, SimpleChange, SimpleChanges, Type } from "@angular/core";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { Subscription } from "rxjs";
import { ModalStack } from "../internals/modal-stack";
import { NgbdModalContentComponent } from "../components/ngb-modal-content-component/ngb-modal-content.component";
import { WafModalRef, WafModalRefImpl } from "../models/waf-modal-ref/waf-modal-ref";

@Injectable()
export class WafModal {
    
    get isModalExists(): boolean {
            return ModalStack.isModalExists;
    }

    constructor(protected ngbModal: NgbModal) {
        }

    closeActiveModal(data?: any) {
            ModalStack.closeActiveModal(data);
    }

    closeModalByComponentRef(componentRef: any, data?: any) {
            ModalStack.closeModalByComponentRef(componentRef, data);
    }

    dismissAllModals(reason: any) {
            ModalStack.dismissAllModals(reason);
    }

    openInModal<T = any>(component: Type<any> | string, size: 'sm' | 'md' | 'lg', componentOptions?: {}, windowClass: string = null, centered: boolean = false): WafModalRef<T> {
            const modalOptions: NgbModalOptions = {
                backdrop: 'static',
            backdropClass: 'custom-modal-backdrop',
            windowClass: windowClass,
            size: size === 'md' ? size as 'sm' : size, // Hack: ng-bootstrap doesn't accept 'md'. Null option doesn't work as 'md' either
            keyboard: false,
            centered: centered
        };

        const modalRef = this.ngbModal.open(component, modalOptions);
        
        this.handleModalZIndexStacking();

        if (componentOptions) {
                const simpleChanges: SimpleChanges = {};

            const onChangableComponent = modalRef.componentInstance as OnChanges;

            if (onChangableComponent.ngOnChanges) {
                    Object.keys(componentOptions).forEach(k => {
                        const oldValue = modalRef.componentInstance[k];
                    const newValue = componentOptions[k];
                    if (oldValue != newValue) {
                            simpleChanges[k] = new SimpleChange(oldValue, newValue, true);
                    }
                });
            }

            Object.assign(modalRef.componentInstance, componentOptions);

            if (onChangableComponent.ngOnChanges) {
                    onChangableComponent.ngOnChanges(simpleChanges);
            }
        }

        ModalStack.addModal(modalRef);

        const promise = new Promise<T>((resolve, reject) => {
                modalRef.result.then(x => resolve(x), x => reject(x));
        });

        const ref = new WafModalRefImpl(modalRef, promise);

        return ref;
    }

    showMessageModalAsync<T>(title: string, text: string, size: 'sm' | 'md' | 'lg', handers: { displayName: string, value: T, style?: any, isDefault?: boolean }[]): Promise<T> {
            const modalOptions: NgbModalOptions = {
                backdrop: 'static',
            backdropClass: 'custom-modal-backdrop',
            size: size === 'md' ? size as 'sm' : size, // Hack: ng-bootstrap doesn't accept 'md'. Null option doesn't work as 'md' either
            keyboard: false,
        };

        const modalRef = this.ngbModal.open(NgbdModalContentComponent, modalOptions);

        this.handleModalZIndexStacking();
        
        ModalStack.addModal(modalRef);

        modalRef.componentInstance.title = title;
        modalRef.componentInstance.text = text;
        modalRef.componentInstance.handlers = handers;

        let closeSubscription: Subscription;
        closeSubscription = modalRef.componentInstance.close.subscribe(x => {
                ModalStack.closeModal(modalRef, x);

            closeSubscription.unsubscribe();
        })


        const promise = new Promise<T>((resolve, reject) => {
                modalRef.result.then(x => resolve(x), x => reject(x));
        });

        return promise;
    }

    private handleModalZIndexStacking(): void {        
        let attempts = 0;
        const maxAttempts = 5;
        
        const updateModalZIndex = () => {
            const modalElements = document.querySelectorAll('.modal');
            const backdropElements = document.querySelectorAll('.modal-backdrop.custom-modal-backdrop');
            
            if (modalElements.length > 0 && backdropElements.length > 0) {
                const baseZIndex = 1000;
                const increment = 10;
                               
                modalElements.forEach((modal: Element, index: number) => {
                    const modalZIndex = baseZIndex + (index * increment) + 5;
                    (modal as HTMLElement).style.zIndex = modalZIndex.toString();
                });
                
                backdropElements.forEach((backdrop: Element, index: number) => {
                    const backdropZIndex = baseZIndex + (index * increment);
                    (backdrop as HTMLElement).style.zIndex = backdropZIndex.toString();
                });
                
                return true;
            }
            
            attempts++;
            if (attempts < maxAttempts) {
                setTimeout(updateModalZIndex, 100);
            }
            return false;
        };
                
        setTimeout(updateModalZIndex, 50);
    }

}
